import { useNavigate } from 'react-router-dom';
import { IDemoMeta } from '../../utils/parse';
import { copyWritingsMap } from '../exampleFilter/copywritings';
import { useContext } from 'react';
import { LanguageContext, LanguageEnum, getCDNDomain } from '../../utils';

export interface IDemoProps {
  demo: IDemoMeta;
  title: string;
  fullPath: string;
  style?: React.CSSProperties;
  demoStyle?: React.CSSProperties;
  [foo: string]: any;
}

function Demo(props: IDemoProps) {
  const navigate = useNavigate();

  const demoPath = 'demo' + `${props.demoType ? `-${props.demoType}` : ''}`;
  const keywordsList: string[] = props.demo.keywords
    ? props.demo.keywords.split(',')
    : [];

  if (
    props.activeKeyword === '' ||
    keywordsList.includes(props.activeKeyword)
  ) {
    return (
      <div
        className="vchart-example-demo"
        style={{
          width: 80,
          height: 100,
          margin: 4,
          padding: 0,
          ...(props.demoStyle ?? {}),
        }}
        onClick={() => {
          if (props.activeKeyword) {
            window.open(
              `/${props.siteType}/${demoPath}/${props.fullPath}?keyword=${props.activeKeyword}`
            );
          } else {
            window.open(`/${props.siteType}/${demoPath}/${props.fullPath}`);
          }
        }}
      >
        <div className="vchart-example-demo-img">
          <img
            src={
              props.demo.cover
                ? (props.demo.cover || '').replace(
                    'tosv.byted.org',
                    'lf9-dp-fe-cms-tos.byteorg.com'
                  )
                : `${getCDNDomain()}/img/vchart/bar-stack.png`
            }
          />
        </div>
        <div
          className="vchart-example-demo-title"
          style={{ display: 'flex', justifyContent: 'center', padding: 0 }}
        >
          <a
            href={`/${props.siteType}/${demoPath}/${props.fullPath}`}
            style={{
              fontSize: '11px',
              color: 'rgba(0, 0, 0, 0.70)',
              maxWidth: '90%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
            onClick={(event) => event.preventDefault()}
          >
            {props.title}
          </a>
        </div>
      </div>
    );
  } else {
    return null;
  }
}

export function ExampleGalleryMobile(props: any) {
  const { groupDemos, activeIndex, demos, activeKeyword, siteType, demoType } =
    props;
  const { language, setLanguage } = useContext(LanguageContext);
  const copyWritings: Record<
    string,
    Record<LanguageEnum, string>
  > = copyWritingsMap[siteType + (demoType ? `-${demoType}` : '')];

  if (activeIndex === 0) {
    return (
      <div
        className="vchart-example-demo-container"
        style={{ background: 'none' }}
      >
        {(groupDemos ?? []).map((groupDemo: any) => (
          <div
            className="vchart-example-demo-container-group"
            style={{ paddingBottom: 20 }}
          >
            <h1
              className="vchart-example-demo-container-group-title"
              style={{ padding: 0, fontSize: '14px' }}
              id={groupDemo.group}
            >
              {/* {groupDemo.group} */}
              {copyWritings[groupDemo.group]?.[language] ?? groupDemo.group}
            </h1>
            <div
              className="vchart-example-demo-container-group-content"
              style={{ width: '100%' }}
            >
              {(groupDemo.filterDemos ?? []).map((datum: any) => (
                <Demo
                  key={datum.data.fullPath}
                  demo={datum.meta}
                  title={datum.title[language]}
                  fullPath={datum.data.fullPath}
                  activeKeyword={activeKeyword}
                  siteType={siteType}
                  demoType={demoType}
                  demoStyle={props.demoStyle}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  } else {
    return (
      <div
        className="vchart-example-demo-container"
        style={{ background: 'none' }}
      >
        <div
          className="vchart-example-demo-container-group"
          style={{ paddingBottom: 20 }}
        >
          <h1
            className="vchart-example-demo-container-group-title"
            style={{ padding: 0, fontSize: '14px' }}
          >
            {/* {activeKeyword} */}
            {copyWritings[activeKeyword][language]}
          </h1>
          <div
            className="vchart-example-demo-container-group-content"
            style={{ width: '100%' }}
          >
            {(demos ?? []).map((datum: any) => (
              <Demo
                key={datum.data.fullPath}
                demo={datum.meta}
                title={datum.title[language]}
                fullPath={datum.data.fullPath}
                activeKeyword={activeKeyword}
                siteType={siteType}
                demoType={demoType}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
}
